import Slider from "react-slick";
import "./styles.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CustomPrevArrow, CustomNextArrow } from "./arrow";
import LoadingDots from "../loadingDots";
import { CategoriasEnum } from "../../utils/constants";
import handleOptionClick from "../../screens/bot/utils/handleOptionClick";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import preventDoubleClick from "../../utils/preventDoubleClick";

const getCategoryInfo = (categoriaID) => CategoriasEnum[categoriaID] || {};

const ServicesCarousel = () => {
  const { filteredCategories } = useConsorcioStore((state) => state);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <div className="carousel-container">
      {filteredCategories.length > 0 && (
        <Slider {...settings}>
          {filteredCategories.map((option, index) => {
            const { title, description } = getCategoryInfo(option.categoriaID);
            const imageUrl = `https://chatbot-cdn.consorciosmycon.com.br/custom/categorias/${option.categoriaID}.svg`;

            const serviceImg = document.createElement("img");
            serviceImg.id = `carousel-img-${index}`;
            serviceImg.alt = title;
            serviceImg.src = imageUrl;
            serviceImg.width = 200;

            serviceImg.onload = () => {
              if (document.getElementById(`carousel-img-loading-${index}`)) {
                document
                  .getElementById(`carousel-img-loading-${index}`)
                  .remove();
              }
              if (
                document.getElementById(`carousel-img-container-${index}`) &&
                !document.getElementById(`carousel-img-${index}`)
              ) {
                document
                  .getElementById(`carousel-img-container-${index}`)
                  .appendChild(serviceImg);
              }
            };

            return (
              <div
                key={option.categoriaID}
                className="carousel-item"
                data-testid={`carousel-item-${index}`}
              >
                <button
                  onClick={() =>
                    preventDoubleClick(async () => {
                      await handleOptionClick(option);
                      option.action();
                    })
                  }
                  className="services-carousel-button"
                  type="button"
                >
                  <div
                    className="services-carousel-image-container"
                    id={`carousel-img-container-${index}`}
                  >
                    <LoadingDots
                      index={index}
                      id={`carousel-img-loading-${index}`}
                      size="small"
                      color="primary"
                    />
                  </div>
                  <div className="options-title">
                    {title || "semtitulo"}
                    <div className="description-options">
                      {description || "Sem descrição"}
                    </div>
                  </div>
                </button>
              </div>
            );
          })}
        </Slider>
      )}
    </div>
  );
};

export default ServicesCarousel;
